"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsWildInvaders_exports = {};
__export(MrsWildInvaders_exports, {
  MrsWildInvaders: () => MrsWildInvaders
});
module.exports = __toCommonJS(MrsWildInvaders_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const MrsWildInvaders = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("mrsWildInvaders"),
  title: "Wild Invaders",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("mrsWildInvaders"),
      title: "Invasive Species",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("mrsWildInvaders"),
        attribution: []
      }),
      defaultAttribute: "species",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Invasive Species",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "species",
              label: "Species",
              buckets: [
                (0, import_topo_map.lookupBucket)("HimalayanBalsam", import_topo_map.marker.lookup(1), "Flora - Himalayan Balsam"),
                (0, import_topo_map.lookupBucket)("GiantHogweed", import_topo_map.marker.lookup(2), "Flora - Giant Hogweed"),
                (0, import_topo_map.lookupBucket)("JapaneseKnotweed", import_topo_map.marker.lookup(3), "Flora - Japanese Knotweed"),
                (0, import_topo_map.lookupBucket)("FloatingPennywort", import_topo_map.marker.lookup(4), "Flora - Floating Pennywort"),
                (0, import_topo_map.lookupBucket)("OtherFlora", import_topo_map.marker.lookup(5), "Flora - Other"),
                (0, import_topo_map.lookupBucket)("SignalCrayfish", import_topo_map.marker.lookup(6), "Fauna - Signal Crayfish"),
                (0, import_topo_map.lookupBucket)("KillerShrimp", import_topo_map.marker.lookup(7), "Fauna - Killer Shrimp"),
                (0, import_topo_map.lookupBucket)("QuaggaMussel", import_topo_map.marker.lookup(8), "Fauna - Quagga Mussel"),
                (0, import_topo_map.lookupBucket)("ChineseMittenCrab", import_topo_map.marker.lookup(9), "Fauna - Chines Mitten Crab"),
                (0, import_topo_map.lookupBucket)("OtherFauna", import_topo_map.marker.lookup(10), "Fauna - Other")
              ]
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "growthStage",
              label: "Growth Stage",
              buckets: [
                (0, import_topo_map.lookupBucket)("SeedlingOrLarvae", import_topo_map.marker.lookup(1), "Seedling or larvae"),
                (0, import_topo_map.lookupBucket)("Juvenile", import_topo_map.marker.lookup(2), "Juvenile"),
                (0, import_topo_map.lookupBucket)("Adult", import_topo_map.marker.lookup(3), "Adult"),
                (0, import_topo_map.lookupBucket)("DeadOrDying", import_topo_map.marker.lookup(4), "Dead or dying")
              ]
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "coverage",
              label: "Coverage",
              buckets: [
                (0, import_topo_map.lookupBucket)("VerySmall", import_topo_map.marker.lookup(1), "Very small (isolated specimens)"),
                (0, import_topo_map.lookupBucket)("Small", import_topo_map.marker.lookup(2), "Small (<1 m2)"),
                (0, import_topo_map.lookupBucket)("Medium", import_topo_map.marker.lookup(3), "Medium (1-5 m2)"),
                (0, import_topo_map.lookupBucket)("Large", import_topo_map.marker.lookup(4), "Large (5-50 m2)"),
                (0, import_topo_map.lookupBucket)("VeryLarge", import_topo_map.marker.lookup(5), "Very large (>50 m2)")
              ]
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "management",
              label: "Management",
              buckets: [
                (0, import_topo_map.lookupBucket)("NoSign", import_topo_map.marker.lookup(1), "No sign of treatment"),
                (0, import_topo_map.lookupBucket)("RemovedManually", import_topo_map.marker.lookup(2), "Removed by hand"),
                (0, import_topo_map.lookupBucket)("RemovedMechanically", import_topo_map.marker.lookup(3), "Removed mechanically"),
                (0, import_topo_map.lookupBucket)("DugOut", import_topo_map.marker.lookup(4), "Dug out"),
                (0, import_topo_map.lookupBucket)("Sprayed", import_topo_map.marker.lookup(5), "Sprayed"),
                (0, import_topo_map.lookupBucket)("StemInjected", import_topo_map.marker.lookup(6), "Stem injected"),
                (0, import_topo_map.lookupBucket)("Other", import_topo_map.marker.lookup(7), "Other treatment")
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsWildInvaders
});
//# sourceMappingURL=MrsWildInvaders.js.map
